// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"4a114474","224":"ca86932a"}[chunkId] + ".chunk.js";
};